import { EuiLink } from "@elastic/eui";
import { FormattedMessage } from "react-intl";
import React from "react";

import AbstractColumnActions from "../../shared/entity/TableColumnAction";

const columns = (actions) => [
    {
        field: "contractDocument",
        name: <FormattedMessage id="contract.document" />,
        render: (item) => (
            <span>
                <EuiLink
                    href={item.url}
                    target="_blank"
                >
                    {item.name}
                </EuiLink>
            </span>
        ),
        sortable: true,
    },
    {
        field: "startDate",
        name: <FormattedMessage id="contract.start-date" />,
        dataType: "date",
        sortable: true,
    },
    {
        field: "endDate",
        name: <FormattedMessage id="contract.end-date" />,
        dataType: "date",
        sortable: true,
    },
    // {
    //     name: 'Actions',
    //     isActionsPopover: true,
    //     actions: AbstractColumnActions(actions),
    // },
];

export default columns;
